import { Box, Skeleton, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toToman } from "../../utils/Utils";
import { ReactComponent as DoubleUpIcon } from "../../assets/icons/double-up-arrow.svg";
import { ReactComponent as DoubleDownIcon } from "../../assets/icons/double-down-arrow.svg";
import CustomTextSkeleton from "../shared/CustomTextSkeleton";

const AssetAmountCard = (props) => {
  const { amount } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 1,
      }}
    >
      <Typography variant="h1" color="common.white">
        {toToman(amount)}
      </Typography>
      <Typography
        variant="subtitle1"
        color="common.white"
        sx={{ opacity: 0.7 }}
      >
        تومان
      </Typography>
    </Box>
  );
};

const RateCard = (props) => {
  const { rate } = props;
  const isNegative = rate < 0;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="h1"
          color={isNegative ? "red.main" : "primary.main"}
        >
          {`%${Math.abs(rate)}`}
        </Typography>
        <Box ml={"4px"}>
          {isNegative ? (
            <DoubleDownIcon width={12} height={14} />
          ) : (
            <DoubleUpIcon width={12} height={14} />
          )}
        </Box>
      </Box>
      <Typography variant="subtitle1" color="common.white">
        از ابتدا
      </Typography>
    </Box>
  );
};

function AssetAmountAndRateCard(props) {
  const { showRate, assetAmount = 0, rate = 0, loading } = props;
  return (
    <Box
      sx={{
        width: "100%",
        px: "24px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body1" color="common.white">
          ارزش‌ سرمایه‌گذاری
        </Typography>
        <KeyboardArrowLeftIcon sx={{ color: "common.white", height: 20 }} />
      </Box>
      {loading ? (
        <>
          <CustomTextSkeleton width={100} />
          <CustomTextSkeleton width={50} />
        </>
      ) : showRate ? (
        <RateCard rate={rate} />
      ) : (
        <AssetAmountCard amount={assetAmount} />
      )}
    </Box>
  );
}

export default AssetAmountAndRateCard;
